export default __webpack_public_path__ + "static/media/desktop_banner_employee.89274289.jpg";